<template lang="pug">
modal#bulk-send-status-help-modal(
  :no-footer='true'
  :no-header='true'
  ref='modal'
  size='lg'
)
  .d-flex.align-items-start.gap-3
    h2.help-title.flex-grow-1.m-0 {{ $t('bulkSendDetails.statusHelp.title') }}
    button.help-close.btn.btn-link.p-0(
      :aria-label='$t("bulkSendDetails.statusHelp.close")'
      @click='close'
      type='button'
    )
      icon(name='xmark')

  .d-flex.flex-column.mt-4
    .help-item(:key='status' v-for='status in statuses')
      span.entry-status.d-inline-flex.align-items-center.gap-2.fw-bold(
        :class='status'
      )
        span.dot.rounded-circle
        | {{ getStatusText(status) }}
      span.help-description {{ $t(`bulkSendDetails.statusHelp.descriptions.${status}`) }}
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import Icon from '@/ui/atoms/Icon.vue';
import BulkSendEntryStatus from '@/enums/BulkSendEntryStatus';

export default {
  name: 'BulkSendStatusHelpModal',
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      statuses: [
        BulkSendEntryStatus.PROCESSING,
        BulkSendEntryStatus.FAILED,
        BulkSendEntryStatus.AWAITING_SIGNATURE,
        BulkSendEntryStatus.SIGNED,
        BulkSendEntryStatus.EXPIRED,
      ],
    };
  },
  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    getStatusText(status) {
      return BulkSendEntryStatus.getText(status, this.$i18n);
    },
  },
};
</script>

<style lang="stylus" scoped>
.help-title
  font-size: 19px
  font-weight: 600
  color: #1F2D2C

.help-close
  color: #4F5C5B

.help-item
  display: grid
  grid-template-columns: 190px minmax(0, 1fr)
  gap: 12px
  align-items: start
  padding: 10px 0
  border-bottom: 1px solid #F0F0F0
  font-size: 13px
  @media (max-width: 576px)
    grid-template-columns: 1fr
    gap: 4px

.help-description
  line-height: 1.5
  color: #4F5C5B

.entry-status
  --status-color: #C9D2D2
  color: #4F5C5B
  &.processing
    --status-color: #F5A623
    color: #B7791F
  &.signed
    --status-color: #0E7A6F
    color: #0E6B5F
  &.awaitingSignature
    --status-color: #F5A623
    color: #B7791F
  &.expired
    --status-color: #8A9696
    color: #5F6B6B
  &.failed
    --status-color: #C0392B
    color: #C0392B

.dot
  flex-shrink: 0
  width: 10px
  height: 10px
  background-color: var(--status-color)
</style>
